import { Navigate, useLocation, Outlet } from "react-router-dom";

export const ProtectedRoutes = () => {
  let location = useLocation();
  const user = JSON.parse(localStorage.getItem("user") as string);
  return user ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};
export default ProtectedRoutes;
